export default "__VITE_ASSET__BawN1X4u__"